// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const TableSortBase: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#231f20",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 8 11" width={width} height={height}>
            <path
                fill="currentColor"
                d="M3.434.46a.87.87 0 0 1 1.132 0l3.199 2.856c.23.205.297.511.172.779s-.415.442-.74.442H.8c-.322 0-.615-.174-.74-.442a.66.66 0 0 1 .173-.779L3.43.46zm0 9.58L.235 7.185a.66.66 0 0 1-.172-.779c.125-.268.415-.442.74-.442h6.394c.323 0 .615.174.74.442a.66.66 0 0 1-.172.779L4.566 10.04a.87.87 0 0 1-1.132 0"
            />
        </svg>
    );
};

export default React.memo(TableSortBase);
